// extracted by mini-css-extract-plugin
export var category = "_hy-9";
export var categoryHeader = "_hy-e";
export var container = "_hy-0";
export var group = "_hy-a";
export var groupItems = "_hy-f";
export var groupSeparator = "_hy-j";
export var loading = "_hy-1";
export var noResults = "_hy-3";
export var placeholder = "_hy-2";
export var resultContent = "_hy-5";
export var resultIcon = "_hy-c";
export var resultItem = "_hy-g";
export var resultMeta = "_hy-8";
export var resultSubtitle = "_hy-7";
export var resultSuffix = "_hy-i";
export var resultTitle = "_hy-6";
export var resultsList = "_hy-4";
export var searchGroup = "_hy-d";
export var selected = "_hy-h";
export var subgroup = "_hy-b";